import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/demo/page.tsx");
